<template>
    <app-modal
        modal-id="duplicates-modal"
        modal-size="large"
        modal-alignment="top"
        @close-modal="$emit('close')"
    >
        <template slot="header">
            <h5 class="modal-title">{{ $t('show_duplicates') }}</h5>
            <button @click="$emit('close')" aria-label="Close" class="close outline-none" data-dismiss="modal" type="button">
                <span><app-icon name="x"></app-icon></span>
            </button>
        </template>

        <template slot="body">
            <app-pre-loader v-if="loading"/>
            <template v-else>
                <div v-if="!duplicates.length" class="text-center py-4">
                    <app-icon name="check-circle" class="text-success mb-3" style="width: 48px; height: 48px;"/>
                    <p class="text-muted">{{ $t('no_duplicates_found') }}</p>
                </div>
                <div v-else>
                    <div class="mb-3 d-flex justify-content-between align-items-center">
                        <span class="text-muted">
                            {{ $t('duplicate_emails_count', {count: totalDuplicateEmails}) }}
                            &middot;
                            {{ $t('extra_entries_count', {count: totalExtraEntries}) }}
                        </span>
                        <button class="btn btn-sm btn-warning" @click="$emit('remove-duplicates')">
                            <app-icon name="trash-2" class="mr-1" style="width: 14px; height: 14px;"/>
                            {{ $t('remove_duplicates') }}
                        </button>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>{{ $t('email') }}</th>
                                    <th>{{ $t('name') }}</th>
                                    <th class="text-center">{{ $t('duplicate') }} #</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(group, gIndex) in duplicates">
                                    <tr v-for="(subscriber, sIndex) in group.subscribers"
                                        :key="`${gIndex}-${sIndex}`"
                                        :class="{'table-warning': sIndex > 0}">
                                        <td>
                                            <template v-if="sIndex === 0">
                                                <strong>{{ group.email }}</strong>
                                            </template>
                                            <template v-else>
                                                <span class="text-muted">{{ group.email }}</span>
                                            </template>
                                        </td>
                                        <td>{{ subscriber.first_name }} {{ subscriber.last_name }}</td>
                                        <td class="text-center">
                                            <span v-if="sIndex === 0" class="badge badge-success">{{ $t('keep') }}</span>
                                            <span v-else class="badge badge-warning">{{ $t('duplicate') }}</span>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </template>

        <template slot="footer">
            <button @click="$emit('close')" class="btn btn-secondary mr-2" data-dismiss="modal" type="button">
                {{ $t('close') }}
            </button>
            <button v-if="duplicates.length" class="btn btn-warning" @click="$emit('remove-duplicates')">
                {{ $t('remove_duplicates') }} ({{ totalExtraEntries }})
            </button>
        </template>
    </app-modal>
</template>

<script>
    import {axiosGet} from "../../../Helpers/AxiosHelper";

    export default {
        name: "DuplicatesModal",
        props: {
            url: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                duplicates: [],
                totalDuplicateEmails: 0,
                totalExtraEntries: 0,
            }
        },
        mounted() {
            this.loadDuplicates();
        },
        methods: {
            loadDuplicates() {
                this.loading = true;
                axiosGet(this.url).then(response => {
                    this.duplicates = response.data.duplicates;
                    this.totalDuplicateEmails = response.data.total_duplicate_emails;
                    this.totalExtraEntries = response.data.total_extra_entries;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    if (error.response) {
                        this.$toastr.e('', error.response.data.message);
                    }
                    this.$emit('close');
                });
            }
        }
    }
</script>
